import { render } from "./Add.vue?vue&type=template&id=2035d4d5&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=2035d4d5&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2035d4d5"],['__file',"resources/js/pages/cantine/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2035d4d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2035d4d5', __exports__)) {
    console.log('reload')
    api.reload('2035d4d5', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=2035d4d5&scoped=true", () => {
    console.log('re-render')
    api.rerender('2035d4d5', render)
  })

}


export default __exports__